import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserWellsService } from '../user-wells.service';
import { WellDetailsModel } from '../_models/well-details-model';
import { AdminWellSearch } from '../_models/admin-well-search';
import { WellDetailsDisplayComponent } from '../well-details-display/well-details-display.component';


@Component({
  selector: 'app-well-lookup',
  templateUrl: './well-lookup.component.html',
  styleUrls: ['./well-lookup.component.css']
})
export class WellLookupComponent implements OnInit {

  wellSearchForm: FormGroup

  wellRecords: WellDetailsModel[];
  errorStatus: boolean;

  detailsWellSubscription: Subscription;
  detailsWellErrorStatusSubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    public userWellService: UserWellsService
  ) {

    this.detailsWellSubscription = this.userWellService.result.subscribe((x) => {
      this.wellRecords = x;
    });

  }

  ngOnInit(): void {
    this.wellSearchForm = this.formBuilder.group({
      wellId: [''],
      uicNumber: [''],
      apiNumber: [''],
      leaseName: [''],
      wellNumber: [''],
      operatorName: [''],
      operatorp5Number: ['']
    });
  }

  onSubmit() {
    let searchRequest: AdminWellSearch = {
      WellId: this.f.wellId.value,
      UicNumber: this.f.uicNumber.value,
      ApiNumber: this.f.apiNumber.value,
      LeaseName: this.f.leaseName.value,
      WellNumber: this.f.wellNumber.value,
      OperatorName: this.f.operatorName.value,
      Operatorp5Number: this.f.operatorp5Number.value,
    }
    this.userWellService.GetWellsAdminSearch(searchRequest);
  }
  get f() { return this.wellSearchForm.controls; }

  ngOnDestroy(): void {
    if (this.detailsWellSubscription != null) {
      this.detailsWellSubscription.unsubscribe();
    }
  }

  clearRecords() {
    this.wellRecords = null;
    this.f.wellId.setValue('');
    this.f.uicNumber.setValue('');
    this.f.apiNumber.setValue('');
    this.f.leaseName.setValue('');
    this.f.wellNumber.setValue('');
    this.f.operatorName.setValue('');
    this.f.operatorp5Number.setValue('');

  }

}
